import DailyMain from "@components/DailyMain";
const Daily: React.FC = () => {
  return (
    <Container>
      <DailyMain />
    </Container>
  );
};

export default Daily;
